import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class NavigationService {
    constructor(router) {
        this.router = router;
    }
    getActualPage() {
        return this.router.url;
    }
    goTo(path) {
        if (this.getValidLogin()) {
            this.router.navigate([path])
                .then(response => console.log('Navigation successful'))
                .catch(error => console.error(`Navigation failed\n${error}`));
        }
        else {
            this.router.navigate(['/login']);
        }
    }
    getValidLogin() {
        const token = sessionStorage.getItem('batoken');
        let valid = false;
        if (token)
            valid = true;
        else
            valid = false;
        return true;
    }
}
NavigationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(i0.ɵɵinject(i1.Router)); }, token: NavigationService, providedIn: "root" });
